export default "__VITE_ASSET__4cc70bf6__"